// Sentry initialization - MUST be imported first in index.js
import * as Sentry from "@sentry/react";

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const ENVIRONMENT = process.env.NODE_ENV || "development";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function initSentry() {
  if (!SENTRY_DSN) {
    console.warn("REACT_APP_SENTRY_DSN not configured. Error tracking disabled.");
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    
    integrations: [
      // Browser tracing for performance monitoring
      Sentry.browserTracingIntegration(),
      // Session replay for debugging (respects privacy)
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    
    // Performance monitoring
    tracesSampleRate: ENVIRONMENT === "production" ? 0.1 : 1.0,
    
    // Session replay sampling
    replaysSessionSampleRate: ENVIRONMENT === "production" ? 0.1 : 0.5,
    replaysOnErrorSampleRate: 1.0, // Always capture replay on error
    
    // Connect frontend traces to backend
    tracePropagationTargets: [
      "localhost",
      "127.0.0.1",
      /^https:\/\/.*\.railway\.app/,
      /^https:\/\/.*\.viajejunto\.com\.br/,
      BACKEND_URL ? new URL(BACKEND_URL).hostname : null,
    ].filter(Boolean),
    
    // Filter sensitive data before sending
    beforeSend(event) {
      // Remove sensitive headers
      if (event.request?.headers) {
        const headers = event.request.headers;
        ['Authorization', 'Cookie', 'X-Auth-Token'].forEach(header => {
          if (headers[header]) {
            headers[header] = '[FILTERED]';
          }
        });
      }
      
      // Remove passwords from breadcrumbs
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.map(breadcrumb => {
          if (breadcrumb.data) {
            const data = { ...breadcrumb.data };
            ['password', 'senha', 'token'].forEach(key => {
              if (data[key]) {
                data[key] = '[FILTERED]';
              }
            });
            breadcrumb.data = data;
          }
          return breadcrumb;
        });
      }
      
      return event;
    },
  });

  console.log(`Sentry initialized for environment: ${ENVIRONMENT}`);
}

// Export Sentry for use in other files
export { Sentry };
